import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from 'src/app/services/interface';
import { ServiceFormService } from '../service-form.service';

// declare var google: any;
@Component({
  selector: 'app-service-transportation',
  templateUrl: './service-transportation.component.html',
  styleUrls: ['./service-transportation.component.scss']
})
export class ServiceTransportationComponent implements OnInit {
  public service: Service;

  @ViewChild('search')
  public searchElementRef!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private serviceFormService: ServiceFormService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.service = this.route.snapshot.parent.data.serviceDetails
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          componentRestrictions: { country: ['UGA', 'IND'] },
        }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result
          let place = autocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          const formattedAddress = place.formatted_address || this.searchElementRef.nativeElement.value
          const coordinates = [place.geometry.location.lng(), place.geometry.location.lat()]
          this.transportFormGroup.get('service_center').patchValue({
            name: formattedAddress,
            gps_coordinates: coordinates
          });
          this.transportFormGroup.controls.service_center.markAsDirty()
        });
      });
    });
  }

  public get transportFormGroup() {
    return this.serviceFormService.transportFormGroup
  }
}
